<div
  class="avatar-container"
  [class]="'avatar-' + size()"
  [style.background-color]="backgroundColor()"
  matTooltipPosition="above"
  matTooltipClass="custom-mat-tooltip"
  [matTooltip]="name()"
>
  <span>
    {{ name() | avatarShortName }}
  </span>
</div>
